export default "__VITE_ASSET__VKqjmMsa__"